import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import Project from 'models/project/project.model';
import User from 'models/user/user.model';
import ProjectPermission from 'models/project-permission/project-permission.model';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import ExternalLayer from 'models/external-layer/external-layer.model';
import { UserService } from 'services/user/user.service';
import { ProjectService } from 'services/project/project.service';
import { OrganizationUnitService } from 'services/organization-unit/organization-unit.service';

@Component({
  selector: 'app-project-layer-connector',
  templateUrl: './project-layer-connector.component.html',
  styleUrls: ['./project-layer-connector.component.scss'],
})
export class ProjectLayerConnectorComponent implements OnInit, OnDestroy {
  @Input() public instance: Project;
  public organizationUnit: OrganizationUnit = new OrganizationUnit();
  public user: User = new User();
  public projectPermission: ProjectPermission = new ProjectPermission();

  private ouSubscription: Subscription;
  private userSubscription: Subscription;

  constructor(
    public router: Router,
    public userService: UserService,
    public snackBar: MatSnackBar,
    public organizationUnitService: OrganizationUnitService,
    public projectService: ProjectService,
  ) { }

  async ngOnInit() {
    this.userSubscription = this.userService.getCurrentUser().subscribe((user) => this.user = user);
    this.ouSubscription = this.organizationUnitService.getOuList().subscribe((list) => {
      const fltr: OrganizationUnit[] = list.filter((ou) => ou.id === this.instance.organizationUnit.id && this.instance.organizationUnit.id.length > 0);
      if (fltr.length > 0) {
        this.organizationUnit = fltr[0];
      }
    });
    await this.organizationUnitService.list();
  }

  async addLayer(layer: ExternalLayer) {
    let snackText = 'Hozzáadás sikerült.';
    try {
      await this.projectService.addLayer(this.instance, [layer.url]);
    } catch (ex) {
      snackText = 'Hozzáadás nem sikerült!';
    } finally {
      this.snackBar.open(snackText, '', {
        duration: 2000,
      });
      await this.projectService.select(this.instance.id);
    }
  }

  async removeLayer(layer: ExternalLayer) {
    let snackText = 'Eltávolítás sikerült.';
    try {
      await this.projectService.removeLayer(this.instance, layer.url);
    } catch (ex) {
      snackText = 'Eltávolítás nem sikerült!';
    } finally {
      this.snackBar.open(snackText, '', {
        duration: 2000,
      });
      await this.projectService.select(this.instance.id);
    }
  }

  async moveLayerUp(layer: ExternalLayer) {
    let snackText = 'Módosítás sikerült.';
    try {
      await this.projectService.moveLayerUp(this.instance, layer.url);
    } catch (ex) {
      snackText = 'Módosítás nem sikerült!';
    } finally {
      this.snackBar.open(snackText, '', {
        duration: 2000,
      });
      await this.projectService.select(this.instance.id);
    }
  }

  async moveLayerDown(layer: ExternalLayer) {
    let snackText = 'Módosítás sikerült.';
    try {
      await this.projectService.moveLayerDown(this.instance, layer.url);
    } catch (ex) {
      snackText = 'Módosítás nem sikerült!';
    } finally {
      this.snackBar.open(snackText, '', {
        duration: 2000,
      });
      await this.projectService.select(this.instance.id);
    }
  }

  isLayerAddedToProject(layer: ExternalLayer) {
    const layerSearch: ExternalLayer[] = this.instance.externalLayers.filter((exLayer) => exLayer.url === layer.url);
    return layerSearch.length > 0;
  }

  async ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.ouSubscription) {
      this.ouSubscription.unsubscribe();
    }
  }
}
